import { ProjectBoxWallGroupWall } from "./ProjectBoxWallGroupWall";

export class ProjectBoxWallGroup {
    public position: number | null = null;
    public walls: Array<ProjectBoxWallGroupWall> | null = null;
}